exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sub-header-title {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.sub-nav-bg-color {\n  background-color: #fafafa;\n}\n\n.role-label {\n  color: #CCCCCC;\n  font-size: 14px;\n  font-style: italic;\n  letter-spacing: 0.01em;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/project/project-detail/project-detail.component.css
// module id = 820
// module chunks = 0